import { useMemo } from "react"
import type { AiTeammateContextValue } from "./types"

/**
 * Custom hook to extract AI Teammate specific analytics properties with memoization.
 * Only recomputes when primitive analytics values change.
 *
 * @param aiTeammateContext - The AI Teammate context value
 * @returns Memoized AI Teammate analytics properties
 */
export function useExtractAiTeammateContextProperties(
  aiTeammateContext: Partial<AiTeammateContextValue>,
) {
  const { threadId, modelMetadata, resourceMetadata, benchmarkMetadata, startDate, endDate } = aiTeammateContext

  // Return memoized object depending only on primitive value
  return useMemo(
    () => ({
      threadId,
      modelId: modelMetadata?.id,
      resourceId: resourceMetadata?.id,
      resourceName: resourceMetadata?.name,
      benchmarkId: benchmarkMetadata?.id,
      benchmarkName: benchmarkMetadata?.name,
      startDate,
      endDate,
    }),
    [threadId, modelMetadata?.id, resourceMetadata?.id, resourceMetadata?.name, benchmarkMetadata?.id, benchmarkMetadata?.name, startDate, endDate],
  )
}
